module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/2.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2F2.png
// module id = BrYr
// module chunks = 93